<template>

<div class="text">

    <input type="text" :placeholder="placeholder" spellcheck="false" :value="value" v-on:keyup="$emit('input', $event.target.value)" />

</div>

</template>

<script>

export default {

    props: ['placeholder', 'value']

}

</script>

<style scoped>

.text input {
    border: 1px solid var(--color-grey-light);
    transition: all 100ms linear;
    font-size: 14px;
    padding: 0px 10px;
    width: 100%;
    height: 40px;
    color: var(--color-grey-dark);
	border-radius: 4px;
}

.text input::placeholder {
    color: var(--color-grey);
}

.text input:focus {
    border-color: var(--color-grey-highlight);
}

</style>
